<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="活动标题：" prop="title">
        <el-input v-model="form.title" placeholder="请输入活动标题"></el-input>
      </el-form-item>
      <el-form-item label="活动地点：" prop="activityPlace">
        <el-input v-model="form.activityPlace" placeholder="请输入活动地点"></el-input>
      </el-form-item>
      <el-form-item label="活动人数：" prop="limitedNumber">
        <el-input v-model.number="form.limitedNumber" placeholder="请输入活动人数"></el-input>
      </el-form-item>
      <el-form-item label="活动时间：" prop="activityTime">
        <el-date-picker
          v-model="form.activityTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请输入活动时间" style="width: 100%;">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="活动内容：" prop="content">
        <el-input :autosize="{ minRows: 4, maxRows: 6}" type="textarea" v-model="form.content"></el-input>
      </el-form-item>
      <el-form-item label="图片：" prop="activityImages">
        <el-upload
          :action="uploadURL"
          list-type="picture-card"
          :multiple="true"
          :headers="headers"
          :limit="9"
          name='file'
          :fileList="fileList"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :on-success="imgChange">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="false">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { infoActivity } from '../../api/publicActive'
export default {
  name: 'userEdit',
  props: ['oldForm'],
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      uploadURL: baseURL + '/web/file/uploadImage',
      headers: {
        'X-Access-Token': sessionStorage.getItem('token'),
      },
      rules: {
        title: [
            { required: true, message: '请输入活动标题', trigger: 'blur' },
          ],
        activityPlace: [{ required: true, message: '请输入活动地点', trigger: 'blur' }],
        limitedNumber: [{ required: true, message: '请输入活动人数', trigger: 'blur' }],
        activityTime: [{ required: true, message: '请输入活动时间', trigger: 'blur' }],
        content: [{ required: true, message: '请输入活动内容', trigger: 'blur' }],
        activityImages: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      form: {
        title: '',
        activityPlace: '',
        limitedNumber: '',
        activityTime: '',
        content: '',
        activityImages: '',
      },
      files:[],
      fileList: [
        // {name:'ffff',url:'http://192.168.2.110:8080/yhs/upload/images/cc_1664262535605.png'}
        ],
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.oldForm));
    if(this.form.id) {
      this.fileList = [];
      infoActivity({id:this.form.id}).then(res=>{
        if(res.success) {
          this.form = res.result;
          let list = res.result.activityImages.split(',');
          for(let i = 0;i<list.length;i++) {
            let str = list[i];
            let name = str.substring(str.lastIndexOf('/')+1);
            name = name.substring(0,name.indexOf('_'));
            let obj = {name,url:baseURL+str,fileUrl:str}
            this.fileList.push(obj);
          }
        }
      })
    }
  },
  methods: {
    handleRemove(file, fileList) {
      if(file.fileUrl) {
        for(let i = 0;i<this.fileList.length;i++) {
          if(this.fileList[i].fileUrl === file.fileUrl) {
            this.fileList.splice(i,1);
            break;
          }
        }
      }else{
        if(file.status == 'success' && file.response && file.response.result) {
          for(let i = 0;i< this.files.length;i++) {
            if(file.response.result == this.files[i]) {
              this.files.splice(i,1);
            }
          }
        }
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    imgChange(response, file) {
      if(response.success) {
        this.$message.success('上传成功! ');
        this.fileList.push({
          name:file.name,
          url: baseURL + response.result,
          fileUrl: response.result
        });
        this.form.activityImages =  'true';
      }else {
        this.$message.error(res.response.message);
      }
    },
    beforeAvatarUpload(file) {
      const types = file.name.substring(file.name.lastIndexOf('.')+1);
      const whiteList = ['jpg','jpeg','png','gif','JPG','JPEG'];
      if(whiteList.indexOf(types) == -1) {
        this.$message.error('请上传正确图片格式');
        return false
      }
    },
    getdatas(){
      let list = [];
      for(let item of this.fileList) {
        list.push(item.fileUrl);
      }
      for(let item of this.files) {
        list.push(item);
      }
      this.form.activityImages = list.join(',');
    }
  }
}
</script>

<style scoped lang="less">
  .el-select{
    width: 100%;
  }
  /deep/ .el-upload--picture-card {
    width: 140px;
    height: 140px;
    line-height: 140px;
  }
  /deep/ .el-upload-list__item {
    width: 140px;
    height: 140px;
  }
  /deep/ .v-model{
    opacity: 0;
  }
  /deep/ .el-textarea__inner {
    max-height: 200px;
  }
</style>